import { useSelector, useDispatch } from 'react-redux';
import {
  getAllCoatingPumphouse,
  bulkSaveCoatingPumphouse,
  clearCoatingPumphouseData,
  clearBulkSaveCoatingPumphouse,
  savePumpHouseLimitConfig,
} from '../actions';

export const useCoatingPumphouse = () => {
  const dispatch = useDispatch();
  const coatingPumphouse = useSelector((state) => state.coatingPumphouse);

  return {
    // GET state
    coatingPumphouseData:    coatingPumphouse.coatingPumphouseData,
    coatingPumphouseLoading: coatingPumphouse.coatingPumphouseLoading,
    coatingPumphouseError:   coatingPumphouse.coatingPumphouseError,
    pumpHouseLimitConfigFromApi: coatingPumphouse.pumpHouseLimitConfigFromApi,

    // POST (bulk save) state
    bulkSaveLoading: coatingPumphouse.bulkSaveLoading,
    bulkSaveSuccess: coatingPumphouse.bulkSaveSuccess,
    bulkSaveError:   coatingPumphouse.bulkSaveError,
    bulkSaveResult:  coatingPumphouse.bulkSaveResult,

    pumpHouseLimitConfigSaveLoading: coatingPumphouse.pumpHouseLimitConfigSaveLoading,
    pumpHouseLimitConfigSaveError: coatingPumphouse.pumpHouseLimitConfigSaveError,

    // Actions
    getAllCoatingPumphouse: (payload) =>
      dispatch(getAllCoatingPumphouse(payload)),
    bulkSaveCoatingPumphouse: (payload) =>
      dispatch(bulkSaveCoatingPumphouse(payload)),
    clearCoatingPumphouseData: () =>
      dispatch(clearCoatingPumphouseData()),
    clearBulkSaveCoatingPumphouse: () =>
      dispatch(clearBulkSaveCoatingPumphouse()),
    savePumpHouseLimitConfig: (payload) =>
      dispatch(savePumpHouseLimitConfig(payload)),
  };
};
